import iconTele from "assets/svg/icon-tele.svg";
import iconTw from "assets/svg/icon-tw.svg";
import iconYoutube from "assets/svg/icon-youtube.svg";
import iconFB from "assets/svg/icon-fb.svg";
import iconTiktok from "assets/svg/icon-tiktok.svg";

export const socials = [
  {
    icon: iconTele,
    href: "https://t.me/pionechain",
  },
  {
    icon: iconTw,
    href: "https://x.com/pione_chain",
  },
  {
    icon: iconYoutube,
    href: "https://www.youtube.com/channel/UCcedtw9YyEVYRO7T5b2gzdg",
  },
  {
    icon: iconFB,
    href: "https://www.facebook.com/pionechain/",
  },
  {
    icon: iconTiktok,
    href: "https://www.tiktok.com/@pione_chain",
  },
];
